import React from 'react'
import { Column, Row } from 'components/layout'
import styled from '@emotion/styled'

const StyledFooterRow = styled.div({
  footer: {
    padding: '2rem 0',
  },

  '.credit': {
    textAlign: 'left',
  },
})

const Footer = (props) => {
  return (
    <StyledFooterRow as={Row} center='xs'>
      <Column xs={12} lg={10}>
        <footer>
          <Row>
            <Column className='credit' xs={3} xsOffset={8}>
              With the support of:
              <br />
              The Center for the Humanities
            </Column>
          </Row>
          <Row>
            <Column xs={1} xsOffset={11}>
              <img src='/images/gc_logo_white.png' alt='The Graduate Center - City Univeristy of New York' />
            </Column>
          </Row>

        </footer>
      </Column>
    </StyledFooterRow>
  )
}

export default Footer
